import instance from 'api/globalaxios';
import { useState, useEffect } from 'react';
import { gethost } from 'slices/disputeSlice';

export const fetchLoanTypes = async () => {
  const response = await instance({
    method: "get",
    url: `api/get-loan-types/` + "?host=" + gethost(),
  });
  return response.data;
};

const useLoanTypes = (enabled = true) => {
  const [loanTypes, setLoanTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if(!enabled ) return;

    fetchLoanTypes()
      .then(data => setLoanTypes(data))
      .catch(err => setError(err))
      .finally(() => setLoading(false));

  }, []);
  return { loanTypes, loading, error };
};

export default useLoanTypes;
